import React, { useEffect, useState, Suspense, lazy, Component } from 'react';
import { Hero } from './components/Hero';
import { useMetaPixel } from './components/useMetaPixel';
const BelowFold = lazy(() => import('./components/BelowFold').then(({
  BelowFold: Component
}) => ({
  default: Component
})));
export function App() {
  const [isBelowFoldReady, setIsBelowFoldReady] = useState(false);
  const [shouldScrollToPurchase, setShouldScrollToPurchase] = useState(false);
  useMetaPixel();
  useEffect(() => {
    const loadBelowFold = () => setIsBelowFoldReady(true);
    const loadWhenApproachingContent = () => {
      if (window.scrollY + window.innerHeight >= 900) loadBelowFold();
    };
    const idleTimer = window.setTimeout(loadBelowFold, 2500);
    window.addEventListener('scroll', loadWhenApproachingContent, {
      passive: true
    });
    window.addEventListener('wheel', loadBelowFold, {
      once: true,
      passive: true
    });
    window.addEventListener('touchstart', loadBelowFold, {
      once: true,
      passive: true
    });
    window.addEventListener('pointerdown', loadBelowFold, {
      once: true,
      passive: true
    });
    return () => {
      window.clearTimeout(idleTimer);
      window.removeEventListener('scroll', loadWhenApproachingContent);
      window.removeEventListener('wheel', loadBelowFold);
      window.removeEventListener('touchstart', loadBelowFold);
      window.removeEventListener('pointerdown', loadBelowFold);
    };
  }, []);
  useEffect(() => {
    if (!isBelowFoldReady || !shouldScrollToPurchase) return;
    const purchaseSection = document.getElementById('planes');
    if (purchaseSection) {
      purchaseSection.scrollIntoView({
        behavior: 'smooth'
      });
      setShouldScrollToPurchase(false);
    }
  }, [isBelowFoldReady, shouldScrollToPurchase]);
  const handlePurchaseRequest = () => {
    setShouldScrollToPurchase(true);
    setIsBelowFoldReady(true);
  };
  return <div className="min-h-screen bg-slate-950 text-slate-50 selection:bg-brand-500/30" data-id="element-0">
      <main data-id="element-1">
        <Hero onPurchaseRequest={handlePurchaseRequest} data-id="element-2" />
        {isBelowFoldReady && <Suspense fallback={null} data-id="element-3">
            <BelowFold data-id="element-4" />
          </Suspense>}
      </main>
    </div>;
}